import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { getHubSpotForStartupsRedirectUrl } from './hubspotForXRedirect';
const getFlowToFallbackUrl = new Map([[Flow.Academy, (portalId, hublet) => `${getApplicationDomain(hublet)}/academy/${portalId}`], [Flow.HubspotForStartups, (portalId, hublet) => getHubSpotForStartupsRedirectUrl({
  portalId,
  hublet
})]]);
export const getFallbackOnboardingUrl = (portalId, hublet, __isNewUser) => {
  const flowKey = getFlowKey();
  const fallback = getFlowToFallbackUrl.get(flowKey);
  if (fallback) {
    return fallback(portalId, hublet);
  }
  return `${getApplicationDomain(hublet)}/getting-started/${portalId}`;
};